import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import Axios from '@services/axios';
import NewCourseCard from '@/components/NewCourseCard';

function Explore() {
  const [sem, setSem] = useState('eight');

  useEffect(() => {
    localStorage.setItem('sem', sem);
  }, [sem]);

  const fetchCourses = async () => {
    const res = await Axios.get(`/collection/${sem}`);
    return res.data.data?.courses || [];
  };

  const { data: courses, isLoading } = useQuery({
    queryKey: ['explore-courses', sem],
    queryFn: fetchCourses,
    staleTime: 1000 * 60 * 15, // 15 minutes
  });

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Explore courses related to you</h1>

      {isLoading ? (
        <p>Loading...</p>
      ) : courses?.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {courses.map((course) => (
            <NewCourseCard key={course._id} course={course} />
          ))}
        </div>
      ) : (
        <p>No courses available right now.</p>
      )}
    </div>
  );
}

export default Explore;
